import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import {
  HospitalityActionState,
  HospitalityInfo,
  HospitalityMeetingBookingSummary,
  HospitalityOrderItem
} from "./hospitality.models";
import { agent } from '@shared/services/agent';
import { BasicUserInfo } from '@shared/models/user.models';

export function getHospitalityInfoFor(office: OfficeEntity): Promise<HospitalityInfo> {
  return agent.requests.get(`/api/v2/hospitality/office/${office.id}`)
}

export function createOrderItem(orderItem: HospitalityOrderItem): Promise<any> {
  return agent.requests.post(`/api/v2/hospitality/order-item`, orderItem)
}

export function updateOrderItemRequest(orderItem: HospitalityOrderItem): Promise<any> {
  return agent.requests.put(`/api/v2/hospitality/order-item`, orderItem)
}

export function deleteOrderItemRequest(orderItem: HospitalityOrderItem): Promise<any> {
  return agent.requests.del(`/api/v2/hospitality/order-item/${orderItem.id}`)
}

export function deleteUserToNotify(user: BasicUserInfo, office: OfficeEntity): Promise<any> {
  return agent.requests.post(`/api/v2/hospitality/user-to-notify/remove`, {userId: user.userId, officeId: office.id})
}

export function addUserToNotify(user: BasicUserInfo, office: OfficeEntity): Promise<any> {
  return agent.requests.post(`/api/v2/hospitality/user-to-notify`, {userId: user.userId, officeId: office.id})
}

export function loadBookedHospitalityItemsForMeetingRoomBooking(bookingId: number): Promise<any> {
  return agent.requests.get(`/api/v2/hospitality/booked-items/${bookingId}`)
}

export function loadHospitalityBookingsForDate(officeId: number, dateString: string): Promise<HospitalityMeetingBookingSummary[]> {
  return agent.requests.get(`/api/v2/hospitality/summary/${officeId}?date=${dateString}`)
}

export function updateHospitalityBookingState(bookingId: number, state: HospitalityActionState): Promise<any> {
  return agent.requests.post(`/api/v2/hospitality/summary/state/${bookingId}`, {status: state})
}
